module.exports = __webpack_public_path__ + "components/flag/static/square/jp-067505e3a31d09a4db93412447d5a92f.svg";